import React from "react";
import { contextapi } from "../helpers/contextapi";

const PageTitle = ({ title, sub }) => {
  const context = React.useContext(contextapi);

  const { student: user } = context.values;
  const tit = title ? title : `Welcome ${user?.firstname}`;
  document.title = `KESPODAK | ` + tit;
  return (
    <div className="mb-3 pb-2 border-bottom">
      <h3 className="font-weight-bold text-uppercase">{title ? title : `Welcome ${user?.firstname}`}</h3>
      <h6 className="font-weight-normal mb-0">{sub ? sub : <span>Your student dashboard</span>}</h6>
    </div>
  );
};

export default PageTitle;
